import { reactive, defineComponent, h, } from 'vue';

import EditPopup from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';
import MdEditorCom from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/MdEditorCom';

import { dragPopupComCreate, } from '@/utils/js/leafletUtils';

import {
  saveOrUpdateRegionAnalysisResult,
  deleteRegionAnalysisResult,
} from '@/api/RegionAnalysisResultApi';

import { message } from '@/utils/js/initVariable';

const toFixed = (num, decimals = 4)=>{
  return parseFloat(num).toFixed(decimals);
}

const pointToLatlng = (pointStr)=>{
  return L.latLng(pointStr.split(','))
}

export const aiComponentCreate = (latlng, target, { layerGroup, map })=>{
  let zoomClose, zoomCloseFn = ()=>{
    zoomClose && zoomClose();
    zoomClose = undefined;
  };
  const dataTaget = reactive({
    ...target,
  })
  const endLatlng = dataTaget['endPoint'] && pointToLatlng(dataTaget['endPoint']),
        zoom = dataTaget['zoomlevel'],
        workSpaceId = target['workSpaceId'];
  
  const { app, zoomFn, group } = dragPopupComCreate(latlng, {}, {
    endLatlng, zoom,
  })(
    defineComponent({
      setup(){
        return ()=> h(EditPopup, {
          title: 'AI解读',
          controls: [
            reactive({ iconName: 'thumbtack', fill:  zoom?'rgb(102, 203, 118)':'rgb(221, 221, 221)',
              onClick: (target, btn, control)=>{
                if(zoomClose){
                  control['fill'] = 'rgb(221, 221, 221)';
                  zoomCloseFn();
                  dataTaget['zoomlevel'] = undefined;
                }else{
                  control['fill'] = 'rgb(102, 203, 118)';
                  zoomClose = zoomFn(map);
                  dataTaget['zoomlevel'] = map.getZoom();
                }
              }, 
            }),
            reactive({
              iconName: 'close-box', fill: 'rgb(6, 180, 221)',
              onClick: (target, btn, control)=>{
                control['loading'] = true;
                if(!dataTaget['id']){
                  group && layerGroup.removeLayer(group);
                  return;
                }
                control['loading'] = true;
                deleteRegionAnalysisResult(workSpaceId, dataTaget['id']).then(res=>{
                  if(res.data.code == 1004){
                    message(res.data.msg, 1);
                    group && layerGroup.removeLayer(group);
                  }
                }).catch(err=>{
                  console.log(err);
                }).finally(()=>{
                  control['loading'] = false;
                });
              },
            })
          ],
          target: undefined,
          style: {
            width: '360px',
          },
        },
          ()=> h(MdEditorCom, {
            text: dataTaget['analysisResult'],
            onChange: (val)=>{
              dataTaget['analysisResult'] = val;
            },
            onSave: (val)=>{
              let marker;
              group.eachLayer((layer)=>{
                if(layer instanceof L.Marker){
                  marker = layer;
                }
              })
              if(!marker){
                message('操作错误', 2);
                return;
              }
              const startPoint = `${ toFixed(latlng.lat) },${ toFixed(latlng.lng) }`,
                    markerLatLng = marker.getLatLng(),
                    endPoint = `${ toFixed(markerLatLng.lat) },${ toFixed(markerLatLng.lng) }`
              saveOrUpdateRegionAnalysisResult(workSpaceId, {
                startPoint, endPoint, ...dataTaget,
              }).then(res=>{
                if(res.data.code == 1004){
                  message(res.data.msg, 1);
                  dataTaget['id'] = res.data.data;
                }
              }).catch(err=>{
                console.log(err);
              });
            },
          })
        )
      }
    })
  );
  
  group.once({
    add: event=>{
      if(zoom){
        zoomClose = zoomFn(map);
      }
    }
  })

  return { app, zoomCloseFn, group };
}